module.exports = __webpack_public_path__ + "fonts/Inter-ExtraLight.4d9f96f.woff2";